import VPageTeacherRankList from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageTeacherRankList', VPageTeacherRankList),
};
